export default __webpack_public_path__ + "static/media/Power_Supply_Leads.7bf84755.svg";